import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { AuthHttpInterceptor, AuthModule } from "@auth0/auth0-angular";

import { GlobalHttpInterceptor } from "@core/interceptors/global-http.interceptor";
import { environment } from "../../environments/environment";

const auth0_audience = 'Tyx_OrderHarness_API';
const auth0_cacheLocation = "localstorage";

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      cacheLocation: auth0_cacheLocation,
      authorizationParams: {
        redirect_uri: environment.auth0.redirectUri + "",
        audience: auth0_audience,
      },
      httpInterceptor: {
        allowedList: [
          {
            uri: `${environment.apiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: auth0_audience,
              },
            },
          },
          {
            uri: `${environment.seqApiUrl}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: auth0_audience,
              },
            },
          },
        ],
      },
    }),
  ],
  exports: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
